<script>
export default {
  name: "SubscriptionsTable",
  props: {
    tab: {
      type: Number,
      default: 0,
    },
    searchValue: {
      type: String,
      default: "",
    },
    openForm: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      data: [],
      params: {
        sort_by: "active_from",
        sort_direction: "desc",
      },
      filters: { dates: [] },
      selected: {},
      expanded: [],
    };
  },
  components: {
    // PassRecord: () => import("@/components/Subscriptions/PassRecord"),
    KaitakSubForm: () => import("@/components/Subscriptions/KaitakSubForm"),
  },
  computed: {
    headers() {
      let initHeaders = [
        {
          text: this.$t("guest"),
          value: "user",
          class: "table-guest table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("phone_number"),
          value: "phone",
          class: "table-guest table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("car_plate"),
          value: "car",
          class: "table-guest table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("start_date"),
          value: "start_date",
          class: "table-date table-header",
          isDesc: true,
        },
        {
          text: this.$t("last_payment"),
          value: "last_payment",
          class: "table-date table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("price_type"),
          value: "price_type",
          sortable: false,
          class: "table-price table-header",
        },
        {
          text: this.$t("total"),
          value: "price",
          sortable: false,
          class: "table-price table-header",
        },
        {
          text: this.$t("status"),
          value: "status",
          sortable: false,
          class: "table-status table-header",
        },
        {
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
          class: "table-status table-header",
        },
      ];
      return initHeaders;
    },
    expandedHeaders() {
      let initHeaders = [
        {
          text: this.$t("guest"),
          value: "user",
          class: "table-guest table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("phone_number"),
          value: "phone",
          class: "table-guest table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("car_plate"),
          value: "car",
          class: "table-guest table-header",
          isDesc: undefined,
        },
        {
          text: this.$t("start_date"),
          value: "start_date",
          class: "table-date table-header",
          isDesc: true,
        },
        {
          text: "",
          value: "created_at",
          sortable: false,
          class: "table-price table-header",
        },
        {
          text: "",
          value: "amount",
          sortable: false,
          class: "table-price table-header",
        },
        {
          text: this.$t("status"),
          value: "status",
          sortable: false,
          class: "table-status table-header",
        },
      ];
      return initHeaders;
    },
    list() {
      return this.$store.state.subscriptions.list;
    },
    customerSvcRecords() {
      return this.$store.state.subscriptions.customer_svc_list;
    },
    loading() {
      return this.$store.state.subscriptions.loading;
    },
    records() {
      let history = [...this.list];
      if (this.tab !== 5) {
        history = history.filter((i) => i.status === this.tab + 1);
      }
      return history;
    },
    places() {
      return this.$store.state.app.places;
    },
    pricings() {
      return this.$store.state.settings.pricings;
    },
  },
  methods: {
    updateData(params) {
      this.$store.dispatch("subscriptions/getList", params);
    },
    filter(filters) {
      this.filters = filters;
      this.params = {
        ...this.params,
        place_id: filters.place_id,
      };

      this.updateData({ ...this.params });
    },
    search(value) {
      this.params = {
        ...this.params,
        filter: value,
      };

      this.updateData({ ...this.params });
    },
    customSort() {},
    expand(value) {
      if (value.transactions) {
        value.expanded = !value.expanded;
        let index = this.expanded.indexOf(value);
        if (index === -1) {
          this.expanded.push(value);
        } else {
          this.expanded.splice(index, 1);
        }
      }
    },
    edit(item) {
      this.selected = item;
      this.$refs.popup.show();
    },
  },
};
</script>

<template>
  <div>
    <v-skeleton-loader v-if="loading" type="table" />
    <v-data-table
      v-else
      :headers="headers"
      :items-per-page="-1"
      class="table"
      :items="records"
      disable-sort
      hide-default-footer
      mobile-breakpoint="0"
      :expanded="expanded"
      @click:row="expand"
      :singleExpand="true"
      :no-data-text="$t('no_data')"
    >
      <template v-for="i in headers" v-slot:[`header.${i.value}`]="{ header }">
        <div
          :key="i.text"
          class="d-flex align-center"
          :class="
            header.value === 'price' ||
            header.value === 'months' ||
            header.value === 'slots'
              ? 'justify-center'
              : ''
          "
        >
          <div
            class="triangle-parent"
            style="height: 12px"
            v-if="header.sortable !== false"
          >
            <div
              class="triangle up"
              @click="customSort(headers.indexOf(header), 0)"
              :class="header.isDesc === false ? 'active' : ''"
            />
            <div
              class="triangle down"
              @click="customSort(headers.indexOf(header), 1)"
              :class="header.isDesc ? 'active' : ''"
            />
          </div>
          <div>{{ header.text }}</div>
        </div>
      </template>

      <template v-slot:[`item.user`]="{ item }">
        <div class="table-user-name">
          <h4>{{ item.first_name }} {{ item.last_name }}</h4>
        </div>
      </template>

      <template v-slot:[`item.car`]="{ item }">
        <div>{{ item.plate_number }}</div>
      </template>

      <template v-slot:[`item.start_date`]="{ item }">
        <div class="table-date">
          {{ $moment(item.start_from).format("DD.MM.YYYY") }}
        </div>
      </template>

      <template v-slot:[`item.last_payment`]="{ item }">
        <div class="table-date">
          {{ $moment(item.last_payment_at).format("DD MMM YYYY [at] HH:mm") }}
        </div>
      </template>

      <template v-slot:[`item.price_type`]="{ item }">
        <div class="table-price text-center">
          {{
            pricings.filter((i) => i.pricing_id === item.pricing_id)[0]
              ? pricings.filter((i) => i.pricing_id === item.pricing_id)[0].description
              : ""
          }}
        </div>
      </template>

      <template v-slot:[`item.price`]="{ item }">
        <div class="table-price text-center">
          {{
            pricings.filter((i) => i.pricing_id === item.pricing_id)[0]
              ? pricings.filter((i) => i.pricing_id === item.pricing_id)[0].price / 100
              : "N/A"
          }}
          HKD
        </div>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <div class="table-status">
          {{ $t(`pass_status[${item.status - 1}]`) }}
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn text class="flat-btn mx-auto" @click="edit(item)">{{ $t("edit") }}</v-btn>
      </template>

      <template #expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          class="pa-0 right-align"
          v-if="item.expanded === true"
        >
          <v-data-table
            :colspan="headers.length"
            :headers="expandedHeaders"
            hide-default-header
            :items-per-page="-1"
            :items="item.transactions"
            class="table expanded-table"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <template v-slot:[`item.created_at`]="{ item }">
              <div class="text-right">
                {{ $moment(item.created_at).format("DD MMM YYYY [at] HH:mm") }}
              </div>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <div class="text-right">{{ item.amount / 100 }}HKD</div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <div :class="`mx-auto px-2 payment-status status-${item.status - 1}`">
                {{ $t(`wallet_status_options[${item.status - 1}]`) }}
              </div>
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
    <!-- <PassRecord ref="popup" :record="selected" /> -->
    <KaitakSubForm ref="popup" :record="selected" />
  </div>
</template>
<style lang="scss">
.right-align {
  .text-start {
    width: 130px;
  }
}
</style>
